import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLoaderData } from "react-router-dom";

import Animation from "@areas/shared/components/chooseLayout/Animation";
import animationStyles from "@areas/shared/components/chooseLayout/styles/animations.module.css";

import { metaActions } from "@store";

import About from "./blocks/About";
import News from "./blocks/News";
import Calendar from "./blocks/Calendar";
import RepublicCompanies from "./blocks/RepublicCompanies";
import Docs from "./blocks/Docs";
import Partners from "./blocks/Partners";
import SwipeBlock from "../../components/newStepWalker/SwipeBlock";
import EventsBlock from "../../components/buttons/EventsBlock";

function smoothScrollElement(element, nextTop, duration = 450) {
  const start = element.scrollTop;
  const change = nextTop - start;
  if (Math.abs(change) < 1) {
    return;
  }

  const startTime = performance.now();

  const step = (now) => {
    const t = Math.min(1, (now - startTime) / duration);
    const eased = 1 - Math.pow(1 - t, 3);
    element.scrollTop = start + change * eased;
    if (t < 1) {
      requestAnimationFrame(step);
    }
  };

  requestAnimationFrame(step);
}

function Page(props) {
  const data = useLoaderData();
  const dispatch = useDispatch();
  const calendarRef = useRef(null);
  const [calendarFilterTypes, setCalendarFilterTypes] = useState(null);

  useEffect(() => {
    dispatch(
      metaActions.setData({
        icon: "/faviconSchoolboy.ico",
        title: "Школьникам",
        description:
          "Школьники и будущие абитуриенты могут пройти профориентацию, с легкостью выбрать специальность и учебное заведение в Республике Башкортостан",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (!calendarFilterTypes?.length) {
      return;
    }

    const target = calendarRef.current;
    if (!target) {
      return;
    }

    // PerfectScrollbar (.content) owns scrolling; native scrollTo(smooth) is ignored
    const scrollContainer = target.closest(".content");
    if (!scrollContainer) {
      return;
    }

    const run = () => {
      const offset =
        target.getBoundingClientRect().top -
        scrollContainer.getBoundingClientRect().top;
      smoothScrollElement(scrollContainer, scrollContainer.scrollTop + offset);
    };

    // Wait for Calendar re-render after filterTypes change
    const id = requestAnimationFrame(() => requestAnimationFrame(run));
    return () => cancelAnimationFrame(id);
  }, [calendarFilterTypes]);

  const handleCalendarFilter = useCallback((types) => {
    setCalendarFilterTypes(types);
  }, []);

  return (
    <div>
      <Animation
        animationIn={animationStyles.swipeLeftIn}
        animationOut={animationStyles.swipeRightOut}
      >
        <About />
      </Animation>
      <Animation>
        <SwipeBlock />
      </Animation>
      <Animation>
        <EventsBlock onCalendarFilter={handleCalendarFilter} />
      </Animation>
      <Animation>
        <News data={data.Pages} />
      </Animation>
      <Animation>
        <div ref={calendarRef}>
          <Calendar data={data.Events} filterTypes={calendarFilterTypes} />
        </div>
      </Animation>
      <Animation>
        <RepublicCompanies />
      </Animation>
      <Animation>
        <Docs />
      </Animation>
      <Animation>
        <Partners />
      </Animation>
    </div>
  );
}

export default Page;
